import _regeneratorRuntime from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-54f90e91"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  "class": "text"
};
var _hoisted_2 = {
  key: 1,
  "class": "text"
};
import { computed, onMounted, nextTick, ref } from 'vue';
import { useElementSize } from '@vueuse/core';
import { t } from '@/i18n';
export default /*#__PURE__*/_defineComponent({
  props: {
    refreshing: Boolean,
    system: Boolean,
    finished: Boolean,
    loading: Boolean,
    error: Boolean,
    pageSize: Number,
    pageIndex: Number,
    list: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    method: {
      type: Object,
      "default": {}
    }
  },
  emits: ['update:refreshing', 'update:loading'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var screenScrollViewRef = ref();
    var size = useElementSize(screenScrollViewRef);
    var refreshingModel = computed({
      get: function get() {
        return props.refreshing;
      },
      set: function set(value) {
        emit('update:refreshing', value);
      }
    });
    var loadingModel = computed({
      get: function get() {
        return props.loading;
      },
      set: function set(value) {
        emit('update:loading', value);
      }
    });
    var onLoad = function onLoad() {
      props.method.onNextLoading();
    };
    var onRefresh = function onRefresh() {
      props.method.onRefresh();
    };
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return nextTick();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_van_list = _resolveComponent("van-list");
      var _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["ScreenScrollView", {
          'system': __props.system
        }]),
        ref: function ref(_value, _refs) {
          _refs['screenScrollViewRef'] = _value;
          screenScrollViewRef.value = _value;
        }
      }, [__props.system ? (_openBlock(), _createBlock(_component_van_pull_refresh, {
        key: 0,
        modelValue: _unref(refreshingModel),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _isRef(refreshingModel) ? refreshingModel.value = $event : null;
        }),
        onRefresh: onRefresh,
        style: _normalizeStyle({
          '--wrapper-min-height': _unref(size).height.value ? "".concat(_unref(size).height.value - 10, "px") : '100%'
        })
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_van_list, {
            onLoad: onLoad,
            "immediate-check": false,
            finished: __props.finished,
            modelValue: _unref(loadingModel),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(loadingModel) ? loadingModel.value = $event : null;
            }),
            error: __props.error,
            "error-text": _unref(t)('Requestfailed'),
            "finished-text": ""
          }, {
            "default": _withCtx(function () {
              return [_renderSlot(_ctx.$slots, "default"), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, function (item, index) {
                return _renderSlot(_ctx.$slots, "item", {
                  key: item,
                  title: item,
                  item: item,
                  index: index
                });
              }), 128)), __props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)('Loading')), 1)) : _createCommentVNode("", true), __props.finished ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('NoMore')), 1)) : _createCommentVNode("", true)];
            }),
            _: 3
          }, 8, ["finished", "modelValue", "error", "error-text"])];
        }),
        _: 3
      }, 8, ["modelValue", "style"])) : _renderSlot(_ctx.$slots, "default", {
        key: 1
      })], 2);
    };
  }
});